import { Link } from 'react-router-dom';
import { useRevealGroup } from 'hooks/useReveal';
import CatalogIcon from 'common/CatalogIcon/CatalogIcon';
import './Catalogs.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Вибір реєстру — ADR-0004, ADR-0005.
 * Було: чотири скляні плитки 450x200 з backdrop-filter і сірою тінню на наведення.
 * Іконка на плитці — швидке візуальне розпізнавання реєстру без читання назви.
 */
const CATALOGS = [
  { key: 'dancers', to: '/catalogs/dancers', ua: 'Танцюристи', en: 'Dancers' },
  { key: 'coaches', to: '/catalogs/coaches', ua: 'Тренери', en: 'Coaches' },
  { key: 'clubs', to: '/catalogs/clubs', ua: 'Клуби', en: 'Clubs' },
  { key: 'judges', to: '/catalogs/judges', ua: 'Судді', en: 'Judges' },
];

export default function Catalogs() {
  const language = useLanguage();
  const gridRef = useRevealGroup('.catalogs-card', { step: 55 });

  return (
    <section className='catalogs section'>
      <div className='container'>
        <header className='catalogs-head'>
          <h1 className='page-title'>{language === 'en' ? 'Registers' : 'Реєстри'}</h1>
          <p className='lede'>
            {language === 'en'
              ? 'The SGOSTU register: clubs, coaches, judges and dancers.'
              : 'Реєстр СГОСТУ: клуби, тренери, судді та танцюристи.'}
          </p>
        </header>

        <div className='catalogs-wrapper' ref={gridRef}>
          {CATALOGS.map((catalog) => (
            <Link to={catalog.to} className='catalogs-card' key={catalog.to}>
              <span className='catalogs-card-main'>
                <span className='catalogs-card-icon'>
                  <CatalogIcon catalog={catalog.key} />
                </span>
                <span className='catalogs-card-name'>{language === 'en' ? catalog.en : catalog.ua}</span>
              </span>
              <svg className='btn-arrow' width='22' height='22' viewBox='0 0 24 24' aria-hidden='true'>
                <path
                  d='M5 12h14M13 6l6 6-6 6'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.6'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
